import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Onboarding } from '../onboarding.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: Onboarding
            },
            {
                path: ':screen/:tab',
                component: Onboarding
            }
        ])
    ],
    exports: [RouterModule]
})
export class OnboardingRoutingModule {}
